function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import { ApiConstants, InjectorHelper, SessionSelectors, ThunkHelper } from 'invision-core';
import { SEARCH_ENTITY_TYPES } from '../constants/search.constants';
import { CustomerSearchArraySelector, CustomerSearchRecordCountSelector } from '../selectors/search.customer.selectors';
import { hideSearchPanel } from './search.actions';
import { CASES_DETAILS_STATE_REDIRECT } from '../../reactRoutes';
export var CUSTOMER_SEARCH = {
  BEGIN: 'CUSTOMER_SEARCH_BEGIN',
  SUCCESS: 'CUSTOMER_SEARCH_SUCCESS',
  FAILURE: 'CUSTOMER_SEARCH_FAILURE'
};
var CUSTOMER_SEARCH_EVENTS = [CUSTOMER_SEARCH.BEGIN, CUSTOMER_SEARCH.SUCCESS, CUSTOMER_SEARCH.FAILURE];
export var CUSTOMER_SEARCH_SUGGESTIONS = {
  BEGIN: 'CUSTOMER_SEARCH_SUGGESTIONS_BEGIN',
  SUCCESS: 'CUSTOMER_SEARCH_SUGGESTIONS_SUCCESS',
  FAILURE: 'CUSTOMER_SEARCH_SUGGESTIONS_FAILURE'
};
var CUSTOMER_SEARCH_SUGGESTIONS_EVENTS = [CUSTOMER_SEARCH_SUGGESTIONS.BEGIN, CUSTOMER_SEARCH_SUGGESTIONS.SUCCESS, CUSTOMER_SEARCH_SUGGESTIONS.FAILURE];
export var CUSTOMER_SEARCH_WITHIN_SUBSCRIBER = {
  BEGIN: 'CUSTOMER_SEARCH_WITHIN_SUBSCRIBER_BEGIN',
  SUCCESS: 'CUSTOMER_SEARCH_WITHIN_SUBSCRIBER_SUCCESS',
  FAILURE: 'CUSTOMER_SEARCH_WITHIN_SUBSCRIBER_FAILURE'
};
export var SET_CUSTOMER_SEARCH_MODEL = 'SET_CUSTOMER_SEARCH_MODEL';
export var setCustomerSearchModel = function setCustomerSearchModel(payload) {
  return {
    type: SET_CUSTOMER_SEARCH_MODEL,
    payload: payload
  };
};
export var RESET_SEARCH_CUSTOMER_MODEL_RECOVERABLE = 'RESET_SEARCH_CUSTOMER_MODEL_RECOVERABLE';
export var resetCustomerSearchRecoverable = function resetCustomerSearchRecoverable() {
  return {
    type: RESET_SEARCH_CUSTOMER_MODEL_RECOVERABLE
  };
};
var CUSTOMER_SEARCH_WITHIN_SUBSCRIBER_EVENTS = [CUSTOMER_SEARCH_WITHIN_SUBSCRIBER.BEGIN, CUSTOMER_SEARCH_WITHIN_SUBSCRIBER.SUCCESS, CUSTOMER_SEARCH_WITHIN_SUBSCRIBER.FAILURE];
var customerSearchPromise = function customerSearchPromise(dispatch, customerSearchModel, pageNumber, pageSize) {
  var events = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : CUSTOMER_SEARCH_EVENTS;
  var $ngRedux = InjectorHelper.getNgReduxService();
  var state = $ngRedux.getState();
  return ThunkHelper(dispatch, events, {
    method: 'post',
    url: 'SubscriberManagement/SearchSubscribers',
    headers: _defineProperty({}, ApiConstants.CUSTOM_SUBSCRIBER_LANGUAGE_HEADER, SessionSelectors.LanguageHeaderSelector(state)),
    data: {
      AddressLineOne: customerSearchModel.addressLineOne,
      CaseNumber: customerSearchModel.caseNumber,
      CaseIdentifier: customerSearchModel.caseIdentifier,
      CommercialName: customerSearchModel.hierarchyName,
      CompanyName: customerSearchModel.companyName,
      ConvergentBillerAccountNumber: customerSearchModel.armAccountNumber,
      DeviceId: customerSearchModel.deviceId,
      DeviceSerialNumber: customerSearchModel.deviceSerialNumber,
      ExternalReferenceId: customerSearchModel.externalId,
      FirstName: customerSearchModel.firstName,
      InvoiceNumber: customerSearchModel.invoiceNumber,
      LastName: customerSearchModel.lastName,
      LoginOrEmailAddress: customerSearchModel.loginOrEmailAddress || customerSearchModel.emailAddress,
      OrderId: customerSearchModel.orderId,
      OrderNumber: customerSearchModel.orderNumber,
      PageSize: pageSize,
      PageNumber: pageNumber,
      PhoneNumber: customerSearchModel.phoneNumber,
      PostalCode: customerSearchModel.postalCode,
      ServiceId: customerSearchModel.serviceId,
      SubscriberId: customerSearchModel.subscriberId,
      SubscriberIdentification: customerSearchModel.subscriberIdentification,
      CategoryType: customerSearchModel.categoryType,
      // Transaction search related fields
      FilterPaymentInstrumentType: customerSearchModel.filterPaymentInstrumentType,
      PaymentInstrumentSubType: customerSearchModel.paymentInstrumentSubType,
      PaymentAccount: customerSearchModel.paymentAccount,
      PaymentReferenceId: customerSearchModel.paymentReferenceId,
      PaymentReconciliationId: customerSearchModel.paymentReconciliationId,
      PaymentTransactionDate: customerSearchModel.paymentTransactionDate,
      PaymentFirstFourDigits: customerSearchModel.paymentFirstFourDigits,
      PaymentLastFourDigits: customerSearchModel.paymentLastFourDigits,
      PurchaseReceiptReference: customerSearchModel.purchaseReceiptReference,
      ReturnUniqueSubscribersByTransaction: customerSearchModel.returnUniqueSubscribersByTransaction,
      SubscriberAdditionalProperties: customerSearchModel.subscriberAdditionalProperties,
      Title: customerSearchModel.title
    }
  });
};
export var getCustomerSearch = function getCustomerSearch(customerSearchModel, pageNumber, pageSize) {
  return function (dispatch) {
    return customerSearchPromise(dispatch, customerSearchModel, pageNumber, pageSize).then(function () {
      var $ngRedux = InjectorHelper.getNgReduxService();
      if (CustomerSearchRecordCountSelector($ngRedux.getState()) === 1) {
        var customer = CustomerSearchArraySelector($ngRedux.getState())[0];
        dispatch(routeToCustomer(customer));
      }
    });
  };
};
var searchSubscriberSSuggestionsPromise = function searchSubscriberSSuggestionsPromise(dispatch, searchString, searchBy, fieldType) {
  return ThunkHelper(dispatch, CUSTOMER_SEARCH_SUGGESTIONS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SearchSubscriberSuggestions',
    data: {
      'SearchString': searchString,
      'SearchBy': searchBy,
      'FieldType': fieldType
    }
  });
};
export var searchSubscriberSuggestions = function searchSubscriberSuggestions(searchString, searchBy) {
  var fieldType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return function (dispatch) {
    return searchSubscriberSSuggestionsPromise(dispatch, searchString, searchBy, fieldType);
  };
};
export var searchCustomersWithinSubscriberEvents = function searchCustomersWithinSubscriberEvents(customerSearchModel, pageNumber, pageSize) {
  return function (dispatch) {
    return customerSearchPromise(dispatch, customerSearchModel, pageNumber, pageSize, CUSTOMER_SEARCH_WITHIN_SUBSCRIBER_EVENTS);
  };
};
export var routeToCustomer = function routeToCustomer(customer) {
  // Defaults state and params
  var state = 'index.customercare.customer';
  var params = {
    customerId: customer.Id
  };
  switch (customer.SearchEntityResult && customer.SearchEntityResult.EntityType) {
    case SEARCH_ENTITY_TYPES.TRANSACTION:
      state = 'index.customercare.customer.transactions.list';
      params.fromTransactionSearch = true;
      break;
    case SEARCH_ENTITY_TYPES.DEVICE:
      state = 'index.customercare.customer.devices';
      params.deviceId = customer.SearchEntityResult.EntityId;
      break;
    case SEARCH_ENTITY_TYPES.ORDER:
      state = 'index.customercare.customer.orderHistory.details';
      params.orderId = customer.SearchEntityResult.EntityId;
      break;
    case SEARCH_ENTITY_TYPES.CASE:
      state = CASES_DETAILS_STATE_REDIRECT;
      params.caseId = customer.SearchEntityResult.EntityId || customer.CaseIdentifier && customer.CaseIdentifier.Value;
      break;
    case SEARCH_ENTITY_TYPES.INVOICE:
      state = 'index.customercare.customer.billingpayments.detail';
      params.invoiceId = customer.SearchEntityResult.EntityId;
      break;
    default:
      break;
  }
  return function (dispatch) {
    dispatch(stateGo(state, params, {
      reload: true
    }));
    dispatch(hideSearchPanel());
  };
};